// extracted by mini-css-extract-plugin
export var dropdownButton = "_1q-0";
export var fullWidthDropdownButton = "_1q-1";
export var icon = "_1q-3";
export var iconPlaceholder = "_1q-2";
export var menuItemRow = "_1q-5";
export var shortcutContainer = "_1q-4";